import { useNavigate } from 'react-router-dom';
export { APIConnector };

function APIConnector() {
    
    const navigate = useNavigate();
	const API_BASE_URL = process.env.NODE_ENV === 'development' ? 
        process.env.REACT_APP_BASE_URL : window.API_URL;

    return {
        get: request('GET'),
        post: request('POST'),
        put: request('PUT'),
        delete: request('DELETE')
    };
s
    function request(method) {
        return async (url, body) => {
            const requestOptions = {
                method,
                headers: authHeader(url)
            };
            if (body) {
                requestOptions.headers['Content-Type'] = 'application/json';
                requestOptions.body = JSON.stringify(body);
            }
            const response = await fetch(API_BASE_URL + url, requestOptions);
            return handleResponse(response);
        }
    }
    
    // helper functions    
    function authHeader(url) {        
        const token = localStorage.getItem('token');
        const isLoggedIn = !!token;
        if (isLoggedIn) {
            return { Authorization: `Bearer ${token}` };
        } else {
            return {};
        }
    }
    
    function handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
			
            if (!response.ok) {	
				/* Handle Error Codes Here */				
				var message = data?.detail ?? "Action Failed";

                switch(response.status){
                    case 400: // failed validation
                        if(data != null)
                        {	
                            if(data.errors != null) {
                                for (const [key, value] of Object.entries(data.errors)) {
                                    message = data.errors[key];
                                }
                            }
                            else if(data.description != null)
                                message = data.description;											
                        }
                        break;
                    case 401: // unauthorized                    		                    	                			
                        localStorage.removeItem('token');
                        navigate('/', 
                            { state: { error: 'Your session has expired. Please Login again' }});
                        return Promise.resolve([{}]);
                    case 403: // forbidden
                        message = "Access Denied";
                        break;
                    case 404: // not found
                        message = "Endpoint Not Found";
                        break;
                    case 500: // internal server error
					    message = "Internal Server Error";
                        break;
                    default:
                        break;
                }    

                return Promise.reject(message);
            }
    
            return data;
        });
    }    
}